import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import {PrimaryButton } from 'Components/Button';

import { Link } from "react-router-dom";

export default class Splash extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <Unauthenticated>
                <div className="flex justify-center full-width">
                    <Link to='/pac-man-game' className="m-5">
                        <PrimaryButton
                            text="Pac Man Game"
                        />
                    </Link>

                    <Link to='/hazard-perception-game'  className="m-5">
                        <PrimaryButton
                            text="Hazard Perception Game"
                        />
                    </Link>
                </div>
            </Unauthenticated>
        );
    }
}
